// Assigned Dependencies
module.exports = (function() {
	/*
	 * MainGroup : Array of jquery selectors to set as show or hidden
	 * Othergroup : Array of jquery selectors to set as the inverse of the Maingroup.
	 * Visible : true for show, false to hide.
	 */
	window.ShowHideElements = function (MainGroup, OtherGroup, visible) {
		for(var i=0; i < MainGroup.length; i++) {
			if (visible) {
				$(MainGroup[i]).show();
			} else {
				$(MainGroup[i]).hide();
			}
		}

		for(var i=0; i < OtherGroup.length; i++) {
			if (visible) {
				$(OtherGroup[i]).hide();
			} else {
				$(OtherGroup[i]).show();
			}
		}
	}

	/*
	*	Element: Button object selected
	*/
	window.FusionDivBoutonsGroup = function (element) {
		var groupName = $(element).attr('data-btn-group-name');	//Get the group name

		//Div => Div => button
		$(element).parent().parent().find('[data-btn-group-name="'+groupName+'"]').removeClass('selected');
		$(element).addClass('selected');
	}

	/*
	*	Call Ajax call and parse the result as a json string
	*
	*	url: Api url
	*	data: data to send to the api (string or array)
	* 	options: associative array of predefine key.
	*	=> onSuccess: function called if a success event is throw.
	*	=> onError: function called if a error event is throw.
	*/
	window.LoadApiData = function (url, data, options) {
		if (options == null) options = {};
		options.url = url;
		options.data = data;

		var localOnSuccess = null;
		if (options.onSuccess != null) {
			localOnSuccess = options.onSuccess;
		}

		options.onSuccess = function (ajaxdata) {
			var json = $.parseJSON(ajaxdata);

			if (localOnSuccess != null) {
				localOnSuccess(json);
			}
		};
		AjaxCall(options);
	}

	/*
	*	Call Ajax call and take the content and put it on a div
	*
	*	selector: jquery selector
	* 	options: associative array of predefine key.
	*	=> onSuccess: function called if a success event is throw.
    * 	=> *: all options accepted by AjaxCall(); (Except onSuccess)
	*/
	window.LoadDiv = function (selector, options) {

		default_opts = {
			showAjaxLoader:true,
			ajaxLoader:'/assets/images/ajax-loader-ball.gif'
		};

		if (options == null) options = {};

		// Set the default values if needed
		for(var index in default_opts) {
			if(typeof options[index] == "undefined") options[index] = default_opts[index];
		}

		if(options.showAjaxLoader){
			$(selector).html('<div class="grid-x align-center"><div class="shrink cell"><img src="'+options.ajaxLoader+'" style="width:55px;height:55px;" alt="'+jQuery.i18n._(6892)+'" /></div></div>');
		}

		var localOnSuccess = null;
		if (options.onSuccess != null) {
			localOnSuccess = options.onSuccess;
		}

		options.onSuccess = function (ajaxdata) {
			var nbForm = $(selector).html(ajaxdata).find('form').length;

			if (nbForm > 0) {
				setupForms();
				LCBDropdown.init()
				LCBAccordion.init()
				window.initMsal()
			}

			if (localOnSuccess != null) {
				localOnSuccess(ajaxdata);
			}
		};

		AjaxCall(options);
	}

	window.SubmitFormDiv = function (formSelector, DivSelector, options) {
		if (options == null) options = {};

		var data = jQuery(formSelector).serializeArray();
		// Get the fuseaction value
		var fuseaction = jQuery.grep(data, function(item) {
			return item.name == 'fuseaction';
		});

		if (fuseaction.length == 0) {
			alert('Invalid fuseaction');
			return;
		}

		//Remove fuseaction from the array
		data = jQuery.grep(data, function(item) {
			return item.name != 'fuseaction';
		});

		LoadDiv(DivSelector,{
			fuseaction: fuseaction[0].value,
			data: data,
			method:'POST'
		});
	}

	/*
	*	Call Ajax call
	*
	* 	options: associative array of predefine key.
	*	=> url: Api url
	*	=> data: data to send to the server (string or array)
	*	=> onSuccess: function called if a success event is throw.
	*	=> onError: function called if a error event is throw.
	*/
	window.AjaxCall = function (options) {
		if (options == null) options = {};

		if (options.fuseaction != null ) {
			options.url = "/index.cfm?fa=" + options.fuseaction;
		}

		if (options.data == null ) {
			options.data = '';
		}

		if (options.method == null ) {
			options.method='GET';
		}

		$.ajax({
				url: options.url,
				data: options.data,
				dataType: 'text',
				cache:false,
				method: options.method,
				success: function (ajaxdata) {

				  if (options.onSuccess != null) {
				  	options.onSuccess(ajaxdata);
				  }
				},
				error: function (e) {
					if (options.onError != null) {
						options.onError(e);
					} else {
						ErrorAjaxCall(e);
					}
				}
		});
	}

	window.ErrorAjaxCall = function (e) {
		GenericErrorHandler();
	}

	/*
	 * Load a underscore template
	 *
	 * templateUrl : URI of the html file,
	 * data : data to pass to the template
	 * 	options: associative array of predefine key.
	 *	=> onSuccess: function called if a success event is throw.
	 *	=> onFail: function called if a fail event is throw
	 */
	window.LoadUnderscoreTemplate = function (templateUrl, data, options) {
		var releaseid = $("meta[name='release-id']").attr('content');

		$.get(templateUrl + '?' + releaseid, function (result) {
			var template = _.template(result);
			var html = template(data);

			if (options.onSuccess !== undefined) {
				options.onSuccess(html);
				LCBDropdown.init()
				LCBAccordion.init()
			}
		}).fail(function(e) {
			// Call a custom event during the fail. if not available call the default one to be sure to display something to the user
			if (options.onFail !== undefined) {
				options.onFail(e);
			} else {
				ErrorAjaxCall(e);
			}
		});
	}

	/*
	 * Insert/replace html into a container
	 *
	 */
	window.LoadTemplateDiv = function (container,html,options) {
		if (options.pagination != null && options.pagination) {
			$(container).append(html);
		} else {
			$(container).html(html);
		}
	}
	/*
	 * Get all the variables from the querystring and return it into an associative array
	 * ignores: variable to excluse from the result
	 */
	window.getQueryVariables = function (ignores) {
		var data = {};
		var query = window.location.search.substring(1);
		var vars = query.split('&');

		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split('=');

			if ((ignores == null) || (ignores.indexOf(pair[0].toLowerCase()) != -1)) {
				data[pair[0]] = pair[1];
			}
		}
		return data;
	}

	window.ShowTabItem = function (NameGroup,ItemID, Fuseaction, FuseParams){
		// Disable all TabOn
		$("td[id^='" + NameGroup + "'].TabOn").each(function() {
			$(this).addClass('TabOff');
			$(this).removeClass('TabOn');
		});

		tab = $('#' + NameGroup + '_' + ItemID);
		tab.addClass('TabOn');
		tab.removeClass('TabOff');

		//prevent the browser from pulling a cached version.
		options = {};
		options.fuseaction = Fuseaction;
		options.data = FuseParams + "&nocache=" + new Date().getTime();
		LoadDiv('#DivTab' + NameGroup ,options);
	}

	window.DeleteUrlFunction = function (sItem,fuseaction,VariableString){
		//8096: "Are you sure you wish to delete this %0 ?"
		var answer = confirm(jQuery.i18n._(8096,[sItem]));
		if (answer) {
			document.location.href = 'index.cfm?fa=' + fuseaction + VariableString;
		}
	}

	/*
	 * Generate a paging list base on the current page.
	 * curPage: current page
	 * totalItems: full total of items
	 * itemsByPage: number of items by page
	 * maxPage: Max page to display. if the number of page is over the max page. the digg style. will take over
	 * adjacentsPage: Only use when we are in digg style. that the number of page to display on each side.
	 * urlPage: a custom url for the page. if not define. we take the window.location.href
	 * pageAnchor: anchor to jump to when a page number is clicked
	 * isAjax: bool to stop href and add the url in the history
	 */
	window.GenPageList = function (curPage, totalItems, itemsByPage, maxPage, adjacentsPage, urlPage, pageAnchor, isAjax) {
		var totalPage = Math.ceil(totalItems / itemsByPage);
		var pageListHTML = '<ul class="pagination">';

		// remove Page= variable from the querystring
		var cMainUrl = (urlPage == null) ? window.location.href : urlPage;
		var regEx = new RegExp("[?&]Page=([0-9])*", "g");
		cMainUrl =  cMainUrl.replace(regEx,"");

		if (curPage > 1) { // Left arrow
			pageListHTML += GenPageBox(curPage-1, false, "&laquo;");
		}
		if (totalPage >= 1) { // First Number
			pageListHTML += GenPageBox(1, curPage == 1, 1);
		}

		var numbersOnly = totalPage < maxPage; // If numbersOnly is true.  Always display digits.
		var leftElipPos = curPage - adjacentsPage - 1;
		var rightElipPos = curPage + adjacentsPage + 1;
		// Only loop over numbers that we could see
		for(var iPageNum=Math.max(leftElipPos, 2); iPageNum <= Math.min(rightElipPos, totalPage-1); iPageNum++) {
			if (numbersOnly || (iPageNum != leftElipPos && iPageNum != rightElipPos)) { // Always show first and last page number.
				pageListHTML += GenPageBox(iPageNum, curPage == iPageNum, iPageNum);
			} else {
				pageListHTML += '<li class="unavailable"><a href="">&hellip;</a></li>';
			}
		}

		if (totalPage >= 2) { // Last Number
			pageListHTML += GenPageBox(totalPage, curPage == totalPage, totalPage);
		}
		if (curPage < totalPage) { // Right arrow
			pageListHTML += GenPageBox(curPage+1, false, "&raquo;");
		}

		return pageListHTML += '</ul>';

		function GenPageBox(pageNum, isSelected, boxText) {
			var cUrl = cMainUrl + ((cMainUrl.indexOf('?') == -1) ? "?" : "&") + 'Page=' + pageNum + pageAnchor;
			// Manage the ajax with jQuery to have more freedom
			var onclick = isAjax ? 'onclick="history.pushState(null, null, &quot;' + cUrl + '&quot;);' + ( pageAnchor.length ? 'location.hash = location.hash;' : '')+ 'return false;"' : "";
			return '<li class="'+ (isSelected ? 'current' : 'arrow') + '"><a href="' + cUrl + '" ' + onclick + '>' + boxText + '</a></li>';
		}
	}

	/*
	 * Generic error handler to insert a dialog div and call the plugin reveal
	 * options: associative array of predefine key.
	 * 		=> title: The title of the dialog if you want to change it. otherwise a default value take over
	 * 		=> message: The message of the dialog if you want to change it. otherwise a default value take over
	 */
	window.GenericErrorHandler = function (options) {
		if (options == null) options = {};
		if (options.title == null) options.title = $.i18n._(7167);
		if (options.message == null) options.message = $.i18n._(13341);

		if ( $('#errors-modal').length == 0) {	//Only insert the dialog div 1 time to the page
			var dialogTemplate = '<div role="dialog" aria-hidden="true" data-reveal class="reveal" id="errors-modal">' +
			'	<div class="wrapper">' +
			'		<div class="wrapper-inner">' +
			'		 	<div class="heading centered black no-margin">' +
			'				<div id="errors-modal-heading" class="title"></div>' +
			'			</div>' +
			'				<div id="errors-modal-message"></div>' +
			'		</div>' +
			'	</div>' +
			'	<a aria-label="Close" class="close-button" data-close><span class="icon-close"></span></a>' +
			'</div>';

			$('body').append(dialogTemplate);
		}

		$('#errors-modal-heading').html(options.title);
		$('#errors-modal-message').html(options.message);
		$('#errors-modal').foundation().foundation('open');
	}

	/*
	 * Used by LinkedListBox components root element to populate the child's options with the result of an ajax call.
	 */
	window.LoadLinkedComponentValues = function (parentComponentID, childComponentID, fuseaction, inOptions, value) {
		var parentComp = jQuery('#'+parentComponentID);
		var queryFilter = parentComp.val();

		if (inOptions == null) {
			inOptions = {};
		}

		var default_args = {
			'param': '',
			'FirstRowValue': '0',
			'FirstRowLabelID': '6872',
			'ShowFirstRow': false,
			'keepDisabled':false,
			'abortPendingAjax':false,
			'LangID':null
		};

		// Set the default values if needed
		for(var index in default_args) {
			if(typeof inOptions[index] == "undefined") inOptions[index] = default_args[index];
		}

		if (queryFilter != 0){
			if (inOptions.abortPendingAjax && parentComp.data(fuseaction)) {
				var xhr = parentComp.data(fuseaction);
				xhr.abort();
			}

			//Disable the parent/child element while it's populated.
			jQuery('#'+childComponentID).attr('selectedIndex', 0).attr('disabled', true);

			// Additionally, disable the custom dropdown
			if (window.dropdownInstances && window.dropdownInstances[childComponentID]) {
				window.dropdownInstances[childComponentID].disableState(true);
			}
			var xhr = jQuery.getJSON("/index.cfm?fa=" + fuseaction + "&queryFilter=" + queryFilter + inOptions["param"],
				function(filteredResult){
				if (inOptions.abortPendingAjax) {
					parentComp.removeData(fuseaction);
				}
				var opt = "";
					// Add the FirstRow if enabled.
					if (inOptions["ShowFirstRow"]) {
						opt = '<option data-first-row="true" value="'+ inOptions["FirstRowValue"] +'">- ' + (inOptions["LangID"] == null ? jQuery.i18n._(inOptions["FirstRowLabelID"]) : jQuery.i18n.__(inOptions["LangID"], inOptions["FirstRowLabelID"])) + ' -</option>';
					}

					// Loop over every rows and insert the values on the child listbox
				for(i=0;i<filteredResult["DATA"].length;i++){
					 opt += '<option value="'+filteredResult["DATA"][i][0]+'">'+filteredResult["DATA"][i][1]+'</option>';
				}

				//re-enabled the parent/child listbox and
				jQuery('#' + childComponentID).html(opt);
				if (!inOptions['keepDisabled']) {
		  			jQuery('#' + childComponentID).removeAttr('disabled');
			  	}
				// Check if the dropdownInstances object and specific instance exist
				if (window.dropdownInstances && window.dropdownInstances[childComponentID]) {
					window.dropdownInstances[childComponentID].updateOptions()
				}
				if (value != null && value != 0) {
	  				values = String(value).split(",");
	  				for(i=0;i<values.length;i++){
	    				jQuery("#"+childComponentID+" option").each(
				      		function(j, itm){
								if(itm.value == values[i]){
									itm.selected = true;
								}
							}
						);
					}
				} else {
					jQuery('#'+childComponentID).attr('selectedIndex', 0);
				}

				if (inOptions["onLoadCompleted"] != null)
					inOptions["onLoadCompleted"]();
				}
			);
			if (inOptions.abortPendingAjax) {
				parentComp.data(fuseaction, xhr);
			}
		} else {
			opt = '<option value="'+ inOptions["FirstRowValue"] +'">- ' + (inOptions["LangID"] == null ? jQuery.i18n._(inOptions["FirstRowLabelID"]) : jQuery.i18n.__(inOptions["LangID"], inOptions["FirstRowLabelID"])) + ' -</option>';
			jQuery('#'+childComponentID).html(opt).attr('disabled', true);
		}
	}

	/*
	 * Open a generic dialog div and call the plugin reveal
	 * options: associative array of predefine key.
	 * 		=> content: text to put inside the dialog
	 * 		=> *: all options accepted by AjaxCall(); (Except onSuccess)
	 */
	window.ShowDialog = function (options) {
		if (window.dialogCount == null) {
			window.dialogCount = 0;
		}

		if (options == null) options = {};

		var divInnerClass = (options.innerClass == null) ? "wrapper-inner" : options.innerClass;

		// Create a new Div tag
		var DivName = "dia_" + window.dialogCount;
		var DivContent = "diaContent_" + window.dialogCount;
		window.dialogCount++;

		var dialogTemplate = '<div role="dialog" aria-hidden="true" data-reveal data-animation-in="fade-in fast" data-animation-out="fade-out fast" class="reveal" id="' + DivName + '">' +
		'	<div class="wrapper">' +
		'		<div class="' + divInnerClass + '" id="' + DivContent + '">' +
		'			<div class="grid-x collapse"><div class="cell centered"><img src="/assets/images/ajax-loader-ball.gif" style="width:55px;height:55px;" alt="Loading" /></div></div>' +
		'		</div>' +
		'	</div>' +
		'	<a aria-label="Close" class="close-button" data-close><span class="icon-close"></span></a>' +
		'</div>';

		$('body').append(dialogTemplate);

		$('#' + DivName + ' [data-close]').on('click', function() {
		  $('#' + DivName).foundation('close');
		});

		options.onSuccess = function(AjaxData){
			$('#' + DivName).foundation().foundation('open');
			LCBDropdown.init();
			LCBAccordion.init();
			LCBLogin.init();
			window.initMsal();
		};
		if (options.content != null) {
			$('#' + DivContent).html(options.content);
			options.onSuccess();
		} else {
			LoadDiv('#' + DivContent, options);
		}

		$(document).on('closed.zf.reveal', '#' + DivName, function () {
		  var modal = $(this).remove();
		});
	}

	/*
	 * Close the current generic dialog
	 */
	window.CloseDialog = function(options){
		$("#dia_" + (window.dialogCount-1)).foundation('close');
	}

	/*
	 * Call the block ui and return true to force the submit
	 */
	window.BlockUIonSubmit = function(){
		jQuery.blockUI();
		return true;
	}

	/*
	 * Trigger a function after the screen was not resized for a given amount of time in milliseconds
	 */
    window.delayedEvents = {};
	window.AddDelayedEventTrigger = function(ms, eventName, callBackFunc, paramArray, triggerOnStart, selector) {
		if (paramArray == null) paramArray = [];
		if (triggerOnStart == null) triggerOnStart = true;
		if (selector == null) selector = window;

		var delayedEventKey = eventName + "_" + selector;
		if (!window.delayedEvents.hasOwnProperty(delayedEventKey)) { // Event is not binded
			window.delayedEvents[delayedEventKey] = [];

			$(selector).bind(eventName, function() {
				var delayedEv = window.delayedEvents[delayedEventKey];
				for (var i = 0; i < delayedEv.length; i++) {
					// Delayed logic is done here
					if(delayedEv[i].resizeTO)  {
						clearTimeout(delayedEv[i].resizeTO);
					}

					delayedEv[i].resizeTO = setTimeout(function(target) {
						target.callBackFunc.apply(window, target.params);
			        }, delayedEv[i].time, delayedEv[i]);
				}
		    });
		}

		window.delayedEvents[delayedEventKey].push({time:ms, callBackFunc:callBackFunc, params:paramArray});

		if (triggerOnStart) {
			callBackFunc.apply(window, paramArray);
		}
	}

	window.PreventSubmitSpam = function(formSelector) {
		$(formSelector).submit(function () {
		    if ($(this).valid()) {
		        $(this).submit(function () {
		            return false;
		        });
		        return true;
		    } else {
		        return false;
		    }
		});
	}

	window.getCookie = function(cookieName) {
		var cookie = document.cookie.split("; ").find(function(cookie){return cookie.substr(0,cookieName.length) == cookieName});
		return cookie ? cookie.split("=")[1] : "";
	};
})();